import { Route, BrowserRouter, Switch } from "react-router-dom";

import PrivateRoute from "./PrivateRoute";

// Paginas
import Home from "../paginas/Home";
import Configuracoes from "../paginas/Configuracoes";
import Conta from "../paginas/Conta";
import NaoEncontrado from "../paginas/NaoEncontrado";
import Autenticacao from "../paginas/Autenticacao";
import Login from "../paginas/Login";
import Cadastro from "../paginas/Login/Cadastro";
import RecuperarSenha from "../paginas/Login/RecuperarSenha";
import AtualizarSenha from "../paginas/Login/AtualizarSenha";
import Recarga from "../paginas/Recarga";
import { Suspense } from "react";
import Loading from "../componentes/loading";

const Rotas = () => {
  return (
    <BrowserRouter>
      <Suspense
        fallback={<Loading loading={true} children={null} cor="orange" />}
      >
        <Switch>
          <Route component={Autenticacao} path="/" exact />
          <Route component={Login} path="/login" exact />
          <Route component={Cadastro} path="/cadastro" exact />
          <Route component={RecuperarSenha} path="/recuperar-senha" exact />
          <Route component={AtualizarSenha} path="/atualizar-senha" exact />
          <PrivateRoute component={Home} path="/home" exact />
          <PrivateRoute component={Configuracoes} path="/configuracoes" exact />
          <PrivateRoute component={Conta} path="/conta" exact />
          <PrivateRoute component={Recarga} path="/recarga" exact />
          <PrivateRoute component={NaoEncontrado} path="*" />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Rotas;
